import {Box, Dialog, Fade, Slide, useMediaQuery, useTheme} from "@mui/material";
import {BaseSyntheticEvent, forwardRef, ReactElement, Ref, useState} from "react";
import {TransitionProps} from "@mui/material/transitions";
import {CreateRandomId} from "../utils/Random";
import {DialogContext, DialogDataContainer} from "../contexts/DialogueContext";

const Transition = forwardRef(function Transition(
    props: TransitionProps & {
        children: ReactElement<any, any>;
    },
    ref: Ref<unknown>,
) {
    return <Fade  ref={ref} {...props} />;
});

// updated
export default function DialogManager(props: {children: JSX.Element | JSX.Element[]}) {


    const [dialogs, setDialogs] = useState<DialogDataContainer[]>([]);

    let [timeoutHandler, setTimeoutHandler] = useState<any>(null);

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

    const openDialog = (element: JSX.Element, onClose?: (result?: any) => void) => {
        const key = CreateRandomId(10);
        const dialog = {element, show: true, key: key, onClose};
        const updatedDialogs = [...dialogs, dialog]
        setDialogs(updatedDialogs);
        clearTimeout(timeoutHandler);
    }

    const closeDialog = (result: any | BaseSyntheticEvent) => {
        // the reason we create new array is that
        // calling reverse will make it in-place
        const updatedDialogs = [...dialogs].reverse()
        for (let dialog of updatedDialogs) {
            if (dialog.show) {
                dialog.show = false;
                if (dialog.onClose) {
                    dialog.onClose(result?.nativeEvent instanceof Event ? null : result);
                }
                break;
            }
        }

        setDialogs(updatedDialogs)
        // startTimerForClearingClosedDialogs();
    }

    const startTimerForClearingClosedDialogs = () => {
        clearTimeout(timeoutHandler);
        const handler = setTimeout(() => {
            clearClosedDialogs();
        }, 5000);
        setTimeoutHandler(handler);
    }

    const clearClosedDialogs = () => {
        if (dialogs.some(m => m.show)) {
            return;
        }
        setDialogs([]);
    }

    const modalValue = {
        dialogs,
        openDialog,
        closeDialog
    }


    return (
        <DialogContext.Provider value={modalValue}>

            {
                props.children
            }

            {
                dialogs.map(elem => {
                    return <Dialog maxWidth={'lg'}
                                   sx={{
                                       overflow: 'visible !important',
                                       animation: elem.show ?
                                           'backDropAnimation 0.3s forwards' :
                                           'backDropAnimationClose 0.3s'
                                   }}
                                   fullScreen={fullScreen}
                                   onClose={closeDialog}
                                   TransitionComponent={Transition}
                                   open={elem.show}
                                   key={elem.key}>{elem.element}</Dialog>
                })
            }
        </DialogContext.Provider>
    )
}

